import { makeStateKey } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { CacheRef, resolverSSGFirst } from './ssg-first.utils';
import type { PaginaEntry } from '@core/interfaces/modyo';

const STATE_KEY = makeStateKey<PaginaEntry>('pagina-pre-biometria');
const cache: CacheRef<PaginaEntry> = { valor: null };

export const resetCacheClientePreBiometria = (): void => {
  cache.valor = null;
};

export const preBiometriaResolver: ResolveFn<PaginaEntry | null> = (): Observable<PaginaEntry | null> =>
  resolverSSGFirst({
    stateKey: STATE_KEY,
    cache,
    rutaSsg: 'pre-biometrica',
    uidTipo: 'pagina',
    slug: 'pagina-pre-biometricos',
  });
